import { render } from "./page-dpp.vue?vue&type=template&id=3b4e72cb"
import script from "./page-dpp.js?vue&type=script&lang=js"
export * from "./page-dpp.js?vue&type=script&lang=js"

import "./page-dpp.vue?vue&type=style&index=0&id=3b4e72cb&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__